import { styled } from '@mui/system';
import { Box } from '@mui/system';

export const HeadingContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	marginBottom: theme.spacing(0.5),
	'@media (max-width: 680px)': {
		display: 'block'
	}
}));

export const SecondContainer = styled('div')(() => ({
	'@media (max-width: 680px)': {
		marginTop: 30,
		marginBottom: 30
	}
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
	marginBottom: 40,
	marginTop: 90,
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	[theme.breakpoints.down('sm')]: {
		flexWrap: 'wrap',
		marginBottom: 20
	}
}));
